import { Injectable } from "@angular/core";
import { ApiService } from "../api/api.service";
import { Organization } from "../../interfaces/organization";
import { Observable } from "rxjs";
import { Guid } from "../../types/guid";

@Injectable({
  providedIn: "root",
})
export class OrganizationsService {
  constructor(private apiService: ApiService) {}

  getOrganizations(): Observable<Organization[]> {
    return this.apiService.getRequest<Organization[]>("orgadmin/organizations");
  }

  setRankingInOrganization(
    OrganizationId: Guid,
    in_ranking: boolean,
  ): Observable<boolean> {
    return this.apiService.putRequest<boolean>(
      `orgadmin/organizations/${OrganizationId}/in_ranking/`,
      { in_ranking },
    );
  }

  downloadLeagueTermsStudentsCsv(): Observable<Blob> {
    return this.apiService.getRequest<Blob>(
      "orgadmin/organizations/league-terms-export/",
      {
        responseType: "blob" as "json",
      },
    );
  }
}
